import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { supabase } from '@/lib/supabase/client';

export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ location }) => {
    // Si el usuario ya esta autenticado, evitar mostrar login/signup redundante.
    // Excepciones:
    //   - accept-invite debe poder correr con sesion activa (es su flujo normal).
    //   - change-password debe poder correr con sesion activa (el usuario tiene must_change_password=true).
    const path = location.pathname;
    if (path.includes('/accept-invite') || path.includes('/change-password')) return;
    const { data } = await supabase.auth.getSession();
    if (data.session) {
      throw redirect({ to: '/' });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <div className="min-h-screen bg-surface-canvas grid place-items-center px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center gap-2">
          <span
            className="text-3xl font-semibold tracking-tight bg-clip-text text-transparent"
            style={{ backgroundImage: 'var(--brand-gradient)' }}
          >
            MEIDEI
          </span>
          {/* i18n */}
          <p className="text-xs text-quiet">Trabajo claro, equipo alineado</p>
        </div>

        <div className="rounded-xl border border-border bg-surface shadow-card p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
